// ./module/comFunction/WmsGetFeatureInfo.js
import CONFIG from '../config/GIS_Config'
// WmsGetFeatureInfo.js

export const createGetFeatureInfo = ({ map, coordinate, layer, layerName, resolution, projection }) => {
  return new Promise((resolve, reject) => {
    try {
      // 添加参数验证
      if (!coordinate || !Array.isArray(coordinate) || coordinate.length < 2) {
        console.error('无效的坐标参数:', coordinate)
        resolve({ features: [] })
        return
      }

      if (!layer || !layer.getSource) {
        console.error('无效的图层参数:', layer)
        resolve({ features: [] })
        return
      }

      const source = layer.getSource()
      const url = source.getFeatureInfoUrl(coordinate, resolution, projection.getCode(), {
        INFO_FORMAT: 'application/json',
        // INFO_FORMAT: 'text/html',
        QUERY_LAYERS: layerName,
        FEATURE_COUNT: 50, // 重叠时，限制可返回最大数
        BUFFER: 8, // 容差像素，根据需求调整
        VERSION: '1.3.0', // 明确指定版本为1.3.0
        exceptions: 'application/vnd.ogc.se_inimage',
        WIDTH: '101',
        HEIGHT: '101',
        // 添加GeoServer专用参数精确查询
        VIEWPARAMS:
          'projectCode:' +
          CONFIG.TopologyProjection +
          ';topologyCode:' +
          CONFIG.TopologyCode +
          '; WHERE:geom && ST_Buffer(ST_MakePoint(' +
          coordinate[0] +
          ',' +
          coordinate[1] +
          ')::geography, 10)::geometry', // 10米缓冲
      })
      // const proxyUrl = url.replace('http://120.71.183.224:8080/geoserver', '/geoserver');
      // debugger
      if (!url) {
        resolve({ features: [] })
        return
      }

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('WMS请求失败')
          return response.json()
        })
        .then(data => ({
          type: data.type || 'FeatureCollection',
          features: data.features || [],
        }))
        .then(resolve)
        .catch(reject)
    } catch (e) {
      reject(e)
    }
  })
}
